import farsi from './farsi.json';
import english from './english.json';
import turkish from './turkish.json';
export var languageList = ['en', 'fa', 'tr'];
var languages = [
    {
        id: 1,
        dir: 'rtl',
        file: farsi,
        lang: 'fa',
        title: 'فا',
        default: true,
    },
    {
        id: 2,
        dir: 'ltr',
        file: english,
        lang: 'en',
        title: 'en',
        default: false,
    },
    {
        id: 3,
        dir: 'ltr',
        file: turkish,
        lang: 'tr',
        title: 'tr',
        default: false,
    },
];
export default languages;
